import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import StaticFileLayout from 'layouts/StaticFileLayout'

const Static = ({ title, filename }) => {
  const { pathname } = useLocation()

  return <StaticFileLayout title={title} filename={filename} key={pathname} />
}

Static.propTypes = {
  title: PropTypes.string.isRequired,
  filename: PropTypes.string.isRequired
}

export default Static
